import React, { useEffect, useState } from "react";

import { Select } from "antd";
import Selectcourse from "./Selectcourse";
import { genericSearch, getuniversities } from "../../HttpRequest/searchcalls";

const University1 = ({ className, placeholder, selectedCountry, userdata, setuserdata }) => {
  const [universityOptions, setUniversityOptions] = useState();
  const [selectedUniversity, setSelectedUniversity] = useState();

  const onChange = (value) => {
    console.log('university-->', value);
    setSelectedUniversity(value);
    if (selectedCountry) {
      setuserdata({
        country: selectedCountry,
        university: value
      })
    } else {
      setuserdata({
        university: value
      })
    }

  };

  useEffect(() => {
    // if (userdata) {
    //   console.log("user university data-->", userdata.university);
    //   if (userdata.university) {
    //     setSelectedUniversity(userdata.country);
    //   }
    // }
    genericSearch('university', 'a', 0, 20).then((response) => {
      console.log("generic search result-->", response);
      const filteredData = response.map(country => ({
        label: country.key,
        value: country.value,
      }));
      setUniversityOptions(filteredData);
    });

  }, []);

  useEffect(() => {
    if (selectedCountry) {
      getuniversities(selectedCountry).then((response) => {
        const filteredData = response.map(country => ({
          label: country.key,
          value: country.value,
        }));
        setUniversityOptions(filteredData);
        // const selectedUniversityValue = userdata.university ? userdata.university : '';
        setSelectedUniversity();
      });
    } else {
      console.log("selectedCountry not found")
    }

  }, [selectedCountry]);


  const onSearch = (value) => {
    console.log("selectedCountry", selectedCountry)
    if (selectedCountry) {
      console.log("search:", value);
    } else {
      console.log("search apiii:", value);
      genericSearch('university', value, 0, 20).then((response) => {
        console.log("generic search result-->", response);
        const filteredData = response.map(country => ({
          label: country.key,
          value: country.value,
        }));
        setUniversityOptions(filteredData);
      });
    }

  };
  // const handlechange = (value, option) => {
  //     // Use the selected value and option as needed
  //     console.log('Selected Value:', value);
  //     console.log('Selected Option:', option.label);

  //     // Update your state or perform other actions
  //     setcourseName((prevCourseName) => ({
  //       ...prevCourseName,
  //       course: value,
  //     }));
  //     localStorage.setItem("course", option.label)
  //   };

  const filterOption = (input, option) => {
    if (selectedCountry) {
      return (
        (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
      );
    }
    return true;
  };

  return (
    <>
      <Select
        showSearch
        bordered={false}
        placeholder={placeholder}
        optionFilterProp="children"
        className={className}
        onChange={onChange}
        onSearch={onSearch}
        filterOption={filterOption}
        style={{
          width: '320px',

          // width: "72%",
          fontWeight: '500',
          whiteSpace: 'nowrap',
          wordBreak: 'break-word',
          overflow: 'hidden',
          border: "none",
          fontSize: "1.1rem",
          fontWeight: "500",
        }}
        options={universityOptions}
        value={selectedUniversity}
      />
      <Selectcourse userdata={userdata} setuserdata={setuserdata} selecteduniversity={selectedUniversity} selectedCountry={selectedCountry} placeholder="Select Course" className="cssfor" />
    </>

  );
};

export default University1;
